// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pquu9","field":"styles_field__1DknD","fieldCol":"styles_fieldCol__13mSV","diffCol":"styles_diffCol__3BSD9","diff":"styles_diff__1UIIX"};